import type { JSX } from 'react';
import type { WireOverview } from '@logistics/contracts';
import type { Me } from '../auth/use-me';
import { now } from '@/lib/clock';
import { button } from '../shell/look';
import { Orb } from '../shell/orb';
import { navigate } from '../shell/use-route';
import { headline, heroLine } from './stats';

/** The overview's banner (design L304–316): the mark, the state of things, what to do next. */
export function Hero({ overview, me }: { overview: WireOverview; me: Me }): JSX.Element {
  const admin = me.role === 'admin';
  return (
    <div className="border-line relative col-span-full grid grid-cols-1 items-center gap-5 tab:gap-9 overflow-hidden rounded-[20px] border bg-[linear-gradient(135deg,var(--surf),color-mix(in_oklch,var(--surf)_80%,var(--accSoft)))] px-5 py-6 tab:grid-cols-[auto_minmax(0,1fr)] tab:px-10 tab:py-9">
      <Orb size={150} />
      <div>
        <div className="text-acc mb-2.5 font-mono text-[11.5px] tracking-[.12em]">
          SYSTEM STATUS
        </div>
        <h1 className="m-0 mb-2.5 text-[34px] leading-[1.1] font-semibold tracking-[-.02em]">
          {headline(overview)}
          <br />
          <span className="text-mute font-normal">Listening on Telegram and Web.</span>
        </h1>
        <p className="text-mute m-0 max-w-[560px] text-[14.5px] leading-[1.55]">
          {heroLine(overview, now())}
        </p>
        <div className="mt-[22px] flex flex-wrap gap-2.5">
          {admin && (
            <button
              type="button"
              className={button.primary}
              onClick={() => navigate({ page: 'sources', action: 'add' })}
            >
              + Add source
            </button>
          )}
          {admin && (
            <button
              type="button"
              className={button.outline}
              onClick={() => navigate({ page: 'users', action: 'add' })}
            >
              + Allow user
            </button>
          )}
          {me.role !== 'viewer' && (
            <button
              type="button"
              className={button.ghostAccent}
              onClick={() => navigate({ page: 'chat' })}
            >
              Ask the agent →
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
